import { useState, useEffect } from "react";
import { DEFAULTS } from "../utils/constants/defaults";

export const useDeferred = (value?: string, delayTime?: number) => {
  const [val, setVal] = useState<string>();
  let timeOutId: NodeJS.Timeout | null = null;

  const cbDebounce = (cb: () => void) => {
    if (timeOutId) {
      clearTimeout(timeOutId);
    }

    timeOutId = setTimeout(() => {
      cb();
    }, delayTime || DEFAULTS.deferredTime);
  };

  useEffect(() => {
    const delay = setTimeout(() => {
      setVal(value);
    }, delayTime || DEFAULTS.deferredTime);

    return () => clearTimeout(delay);
  }, [delayTime, value]);

  return { val, cbDebounce };
};
